import { render, staticRenderFns } from "./FiduciaList.vue?vue&type=template&id=ffdf8ccc&"
import script from "./FiduciaList.vue?vue&type=script&lang=js&"
export * from "./FiduciaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports